import leaveFeedback from './leaveFeedback';

export default leaveFeedback;
